

(function () {
  const dataTarget = document.currentScript.dataset.target;

  const sectionContainer = document.querySelector(dataTarget);
  const collectionTabsSliders = Array.from(
    sectionContainer.querySelectorAll('.collection-tabs__swiper')
  );

  collectionTabsSliders.forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: "auto"
    });
  });
})();
